<template>
    <div>
        <ReportTemplate
            :loading="!initialized"
            title="Room Movement Report"
            :permission="PERMISSION_CODES.CMS_VIEW_REPORT_INVENTORY_TRANSFER"
            :filters="filters"
            :columns="columns"
            fetchRoute="/reports/room-movements"
            :reportTypeCode="REPORT_MASTER_CODES.INVENTORY_TRANSACTION"
        />
    </div>
</template>

<script>
import ReportTemplate from "../ReportTemplate.vue"
import { mapState } from "vuex"
import ReportFilter from "../../../models/ReportFilter"
import { PERMISSION_CODES } from "../../../store/permission"

export default {
    components: { ReportTemplate },
    data() {
        return {
            filters: [],
            initialized: false,
            intervalId: null,
            PERMISSION_CODES,
            columns: [
                { title: "Location", key: "warehouse_name" },
                { title: "From Room", key: "from_room" },
                { title: "To Room", key: "to_room" },
                { title: "Product", key: "item_name" },
                { title: "Batch #", key: "batch_no" },
                { title: "Qty", key: "qty" },
                { title: "User", key: "user_name" },
                { title: "When", key: "created_at_formatted" },
                { title: "Reference", key: "ref_name", linkKey: "ref_link" },
            ],
        }
    },
    computed: {
        ...mapState("misc", ["warehouses", "REPORT_MASTER_CODES"]),
    },
    mounted() {
        this.intervalId = setInterval(() => this.initialize(), 800)
    },
    beforeDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId)
            this.intervalId = null
        }
    },
    methods: {
        initialize() {
            if (this.warehouses.length) {
                this.filters.push(
                    new ReportFilter(
                        "Locations",
                        this.warehouses.map(w => ({ id: w.id, title: w.name })),
                        true,
                        "warehouse_ids"
                    ),
                )
                clearInterval(this.intervalId)
                this.initialized = true
            }
        },
    },
}
</script>

<style></style>

